import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import RestaurantCard from './RestaurantCard';

/**
 * Marketplace row — themed band like "Trending Near You" / "Top Rated" / "New on NoFee".
 * Renders a responsive grid (2 mobile · 4 tablet · 5 desktop · 6 widescreen).
 *
 * Accepts an optional `badges` mapping to highlight certain badges on every card in the row,
 * and an `accentBadge` shorthand that puts the same badge on all cards (e.g. row="Trending" → "trending").
 */
const MarketplaceRow = ({
  title,
  subtitle,
  Icon,
  iconClass = 'text-gold-400',
  restaurants = [],
  accentBadge = null,
  viewAllHref = '/restaurants',
  testId,
  limit = 6,
}) => {
  if (!restaurants || restaurants.length === 0) return null;
  const items = restaurants.slice(0, limit);

  return (
    <section className="relative" data-testid={testId || `row-${(title || '').toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-end justify-between mb-3.5 gap-3 flex-wrap">
        <div className="flex items-center gap-2.5 min-w-0">
          {Icon && (
            <span className="w-9 h-9 rounded-xl border border-gold-500/30 bg-gold-500/[0.06] flex items-center justify-center flex-shrink-0">
              <Icon className={`w-4 h-4 ${iconClass}`} strokeWidth={1.6} />
            </span>
          )}
          <div className="min-w-0">
            <h2 className="text-[20px] sm:text-[22px] lg:text-2xl font-extrabold text-white tracking-tight leading-none truncate">
              {title}
            </h2>
            {subtitle && (
              <p className="text-[11.5px] text-white/45 mt-1.5">{subtitle}</p>
            )}
          </div>
        </div>
        <Link
          to={viewAllHref}
          className="text-[12.5px] font-bold text-gold-400 hover:text-gold-300 inline-flex items-center gap-1 flex-shrink-0"
        >
          See all <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-6 gap-3 lg:gap-4">
        {items.map((r) => (
          <RestaurantCard
            key={r.id}
            r={r}
            badges={accentBadge ? [accentBadge] : []}
          />
        ))}
      </div>
    </section>
  );
};

export default MarketplaceRow;
